import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { versionStatusRequest, versionStatusFailure, versionStatusSuccess} from '../reducers/versionStatus';
import { API_LINK } from '../../constants';
import { learnerVersionsRequest } from '../reducers/savedVersions';

const API = `${API_LINK}/api/versionStatus/`;

function* versionStatusAxios() {

  const state = yield select(fullState => fullState);

  const userId = state.loginReducer.user.isTeamLeader
    ? state.teamMembersFullReducer.selectedTeamMemberId
    : state.loginReducer.user.userId;
    const {
      token,
    } = state.loginReducer;

    const { selectedVersionId } = state.userProgramsFullReducer;
  const {
    status
  } = state.versionStatusReducer;

  const response = yield call(() => {
console.log('SEND', state.userProgramsFullReducer)
  return axios({
    method: 'put',
    url: API+selectedVersionId,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      Authorization: `Bearer ${token}`,
    },
   
    credentials: 'same-origin',
    data: {
      status: status, 
     
    },
  });
});

  return response;
}

function* workerVersionStatusSaga() {
  console.log('versionStatus')
  try {
    const response = yield call(versionStatusAxios);
    const responseFromVersionStatus= response.data;
    yield put(learnerVersionsRequest());

    yield put(versionStatusSuccess(responseFromVersionStatus));
    if (response.status === 500) {
      yield put(versionStatusFailure(responseFromVersionStatus));
    }
  } catch (error) {
    yield put(versionStatusFailure(error));
  }
}

export function* watcherVersionStatusSaga() {
  yield takeLatest(versionStatusRequest().type, workerVersionStatusSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/post_versionStatus.js